import { MainContainer } from './components/main/maincontainer/MainContainer';

const App = () => {
  
  return (
    <div style={{overflow:'auto'}}>
      <MainContainer />
    </div>
  );
}

export default App;
